export const GET_ALL_LEADS = "GET_ALL_LEADS"
export const GET_ALL_INSURER = "GET_ALL_INSURER"